<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <el-col v-if="form.parentCode" :span="22">
      <el-form-item :label="$t('SettingBaseDataRegion.addAndEdit.superiorArea')" prop="parentName">
        <BjInput
          v-model="form.parentName"
          :maxlength="MAX_LENGTH.DEFAULT"
          disabled
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('SettingBaseDataRegion.addAndEdit.code')" prop="areaCode">
        <BjInput
          v-model="form.areaCode"
          :maxlength="MAX_LENGTH.DEFAULT"
          :disabled="isEdit"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label=" $t('SettingBaseDataRegion.addAndEdit.name')" prop="name">
        <BjInput
          v-model="form.name"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('SettingBaseDataRegion.addAndEdit.abbreviation')" prop="shortName">
        <BjInput
          v-model="form.shortName"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { commonApi } from '@/api';
const getDefaultForm = () => {
  return {
    _innerMap: {},
    parentName: null,
    parentCode: null,
    areaCode: null,
    name: null,
    shortName: null,
    id: null,
    level: 0,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        countryCode: [{ required: true, message: this.$t('SettingBaseDataRegion.addAndEdit.countryCodeText'), trigger: 'blur' }],
        countryName: [{ required: true, message: this.$t('SettingBaseDataRegion.addAndEdit.countryNameText'), trigger: 'blur' }],
        enabledFlag: [{ required: true, message: '', trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    afterUpload(res) {
      this.form.logo = res;
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('SettingBaseDataRegion.addAndEdit.editTitle') : this.$t('SettingBaseDataRegion.addAndEdit.addTitle'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    setForm(data) {
      this.form = {
        ...this.form,
        ...data,
      };
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }
      delete API_DATA.parentName;

      if (!API_DATA.parentCode) API_DATA.parentCode == 0;
      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      commonApi.addArea(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      commonApi.updateArea(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
